require('./dist/badge/ds6/badge.css');
